import { __decorate } from "tslib";
import React from 'react';
import C7nAvatar from 'choerodon-ui/lib/skeleton/Avatar';
import { observer } from 'mobx-react';
import DataSetComponent from '../data-set/DataSetComponent';
let Avatar = class Avatar extends DataSetComponent {
    render() {
        const { ...otherProps } = this.props;
        const props = {};
        return React.createElement(C7nAvatar, Object.assign({}, otherProps, props));
    }
};
Avatar.displayName = 'Avatar';
Avatar = __decorate([
    observer
], Avatar);
export default Avatar;
